import { Alert, theme } from '@veeqo/ui';
import styled from 'styled-components';

export const AlertEl = styled(Alert)`
  width: 100%;
  max-width: 650px;
  min-height: 5.375rem;
  margin: ${theme.sizes.md} auto 0;

  svg {
    flex: 0 0 ${theme.sizes.md};
  }
`;
